import {
  FieldError, FieldPath, FieldValues, UseFormRegister,
} from 'react-hook-form'
import { handleOnKeyDown } from 'src/utils/Form'
import Modal from 'src/components/Modal'
import * as S from './BadgeValidationModal.styles'
import { fixInputSx } from 'src/features/restocking/utils'

interface BadgeValidationModalProps<T extends FieldValues, K extends FieldPath<T>> {
  show: boolean
  title: string
  dataTestId: string
  inputName: K
  errors: FieldError | undefined
  errorMessage?: string;
  closedButton?: boolean
  register: UseFormRegister<T>
  onClose: () => any
  actionFunction: () => void
}

const BadgeValidationModal = <T extends FieldValues, K extends FieldPath<T>>(
  props: BadgeValidationModalProps<T, K>,
) => {
  const {
    show,
    title,
    closedButton,
    dataTestId,
    onClose,
    actionFunction,
    register,
    inputName,
    errors,
    errorMessage,
  } = props

  return (
    <Modal
      show={show}
      testId={dataTestId}
      centered
      title={title}
      closeButtonAction={onClose}
      closedButton={closedButton}
      body={(
        <S.Container>
          <S.CustomTextField
            sx={fixInputSx}
            id='badgeSupervisor'
            name='badgeSupervisor'
            type='password'
            autoComplete='off'
            inputProps={{ ...register(inputName), 'data-testid': 'badge-validation-modal-input-test-id' }}
            error={!!errors}
            label='badge'
            helperText={!!errors && errorMessage}
            fullWidth
            size='medium'
            onKeyDown={(e) => handleOnKeyDown(e, '', actionFunction)}
          />
        </S.Container>
      )}
    />
  )
}

export default BadgeValidationModal
